<template>
  <ul>
    <li v-for="group in groups">
      <sprite name="iconCheck" class="icon-complete" v-if="group.complete" />
      <sprite name="iconCheckOutline" class="icon-incomplete" v-else />
      <h3>{{ group.title }}</h3>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'AssignmentCompletionSummary',
    props: {
      responses: {
        type: Array,
        required: true
      }
    },
    computed: {
      groups () {
        let groups = _.groupBy(this.responses, "question.groupId")
        const titles = {
          7: "Comprehension",
          10: "Blast Prompt",
          9: "Write Prompt",
          11: "QuikPoll"
        }
        return _.map(groups, (responses, id) => {
          return {
            title: titles[id],
            complete: _.every(responses, (response) => { return !!response.response })
          }
        })
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
    margin-bottom:3rem;
  }

  li {
    display:flex; align-items:center;
  }

  li + li {
    margin-top:1.5rem;
  }

  h3 {
    @include font-size(medium, $headline: true);
    flex:2;
  }

  svg {
    @include size(2rem);
    margin-right:2rem;
  }

  .icon-complete {
    fill:$color-primary;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/assignment-completion-summary.vue